/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { getRouteCarForTotalTime } from "../../../actions/navitimeAPI";
import moment from "moment";
import AdminInputLocation from "../components/AdminInputLocation";
import AdminInputDatePicker from "../components/AdminInputDatePicker";
import AdminCheckbox from "../components/AdminCheckbox";
import AdminInput from "../components/AdminInput";
import AdminInputTimePicker from "../components/AdminInputTimePicker";
import AdminInputPassengers from "../components/AdminInputPassengers";
import AdminInputLuggage from "../components/AdminInputLuggage";
import { LuggageIcon, CalendarAltIcon, PaxIcon, LocationPinIcon, PlusIcon, DeleteIcon, CloseIcon } from "../../icons";

export const SpecifiedDestinationQuotation = ({ searchAvailableVehicles, editFormAvailableVehicle = null }) => {

  const [formData, setByFormData] = useState({
    pickupLocation: null,
    dropoffLocations: [null],
    usageDuration: null,
    travelDate: null,
    pickupTimeRaw: null,
    estpPickupTime: null,
    travelArea: null,
    luggage: {
      cabinSize: 0,
      checkinSize: 0,
    },
    pax: {
      adult: 0,
      child: 0,
      toddler: 0,
      baby: 0,
    },
    byTheHourBook: false,
    bookingType: "specifiedDestination",
    isAirportTransfer: false,
    isFromAirport: false,
    isToAirport: false,
    isStationTransfer: false,
    isFromStation: false,
    isToStation: false,
    longDistance: false,
    totalDistance: 0,
    driverAccomodation: false
  });

  useEffect(() => {
    if (editFormAvailableVehicle != null) {
      setByFormData(editFormAvailableVehicle);
    }
  }, [editFormAvailableVehicle])

  const handlePickupLocation = (location) => {
    if (location === undefined) return;
    const level1 = location.address_components.find(c => c.types.includes("administrative_area_level_1"));

    const city = level1?.long_name || null;
    location.lat = location.geometry.location.lat;
    location.lon = location.geometry.location.lng;
    location.label = location.name + ", " + location.formatted_address;
    location.formatted_address = location.name + ", " + location.formatted_address;
    location.value = location.place_id;
    location.city = city;
    location.prefecture = city;
    location.description = location.description
    setByFormData({ ...formData, pickupLocation: location });
  };

  const handleDropOffLocation = (location, index) => {
    const level1 = location.address_components.find(c => c.types.includes("administrative_area_level_1"));

    const city = level1?.long_name || null;
    location.lat = location.geometry.location.lat;
    location.lon = location.geometry.location.lng;
    location.label = location.name + ", " + location.formatted_address;
    location.formatted_address = location.name + ", " + location.formatted_address;
    location.value = location.place_id;
    location.description = location.description
    location.city = city;
    location.prefecture = city;
    const newDropoffLocations = [...formData.dropoffLocations];
    newDropoffLocations[index] = location;

    setByFormData({ ...formData, dropoffLocations: newDropoffLocations });
  };

  const handleTravelDate = (date) => {
    const formattedDate = moment(date).local().format("YYYY-MM-DD");
    setByFormData({ ...formData, travelDate: formattedDate });
  };

  const handlePickupTime = (time) => {
    const formattedTime = moment(time).local().format("HH:mm");
    setByFormData({ ...formData, pickupTimeRaw: formattedTime });
  };

  const handleOnChangeLuggage = (luggage, amount) => {
    setByFormData((prevForm) => {
      const newLugage = { ...prevForm.luggage };

      if (luggage === "cabin") {
        newLugage.cabinSize = Math.max(0, newLugage.cabinSize + amount);
      } else if (luggage === "checkin") {
        newLugage.checkinSize = Math.max(0, newLugage.checkinSize + amount);
      }

      return {
        ...prevForm,
        luggage: newLugage,
      };
    });
  };

  const handleOnChangePax = (pax, amount) => {
    setByFormData((prevForm) => {
      const newPax = { ...prevForm.pax };

      if (pax === "adult") {
        newPax.adult = Math.max(0, newPax.adult + amount);
      } else if (pax === "child") {
        newPax.child = Math.max(0, newPax.child + amount);
      } else if (pax === "toddler") {
        newPax.toddler = Math.max(0, newPax.toddler + amount);
      } else if (pax === "baby") {
        newPax.baby = Math.max(0, newPax.baby + amount);
      }

      return {
        ...prevForm,
        pax: newPax,
      };
    });
  };

  const checkIsAirportOrStation = (pickupLocation, dropoffLocations) => {
    const AIRPORT_KEYWORDS = ["airport", "空港"];
    const STATION_KEYWORDS = ["station", "駅"];

    const AIRPORT_NAMES = ["haneda", "羽田", "narita", "成田", "kansai", "関西", "itami", "伊丹", "chubu", "chubu centrair", "中部国際"];
    const STATION_NAMES = ["tokyo", "東京", "shinjuku", "新宿", "shinagawa", "品川"];

    const isMatchingPlace = (location, typeKeywords, nameKeywords) => {
      if (!location || !location.formatted_address || !location.types) return { isMatch: false, type: "none" };

      const typesLower = location.types.map(t => t.toLowerCase());
      const addressParts = location.formatted_address.toLowerCase().split(",");

      if (typesLower.includes("airport") || typesLower.includes("train_station") || typesLower.includes("subway_station")) {
        // Check for matching type and address parts
        for (let i = 0; i < addressParts.length; i++) {
          for (let keyword of typeKeywords) {
            for (let name of nameKeywords) {
              if (
                addressParts[i].includes(name) &&
                addressParts[i].includes(keyword)
              ) {
                return { isMatch: true, type: keyword === "airport" || keyword === "空港" ? "airport" : "station" };
              }
            }
          }
        }
      }

      return { isMatch: false, type: "none" };
    };

    const pickup = isMatchingPlace(pickupLocation, [...AIRPORT_KEYWORDS, ...STATION_KEYWORDS], [...AIRPORT_NAMES, ...STATION_NAMES]);
    const dropoffLoc = dropoffLocations?.[dropoffLocations.length - 1];
    const dropoff = isMatchingPlace(dropoffLoc, [...AIRPORT_KEYWORDS, ...STATION_KEYWORDS], [...AIRPORT_NAMES, ...STATION_NAMES]);

    return {
      check: pickup.isMatch || dropoff.isMatch,
      pickupStatus: pickup.isMatch,
      dropoffStatus: dropoff.isMatch,
      pickupType: pickup.type,
      dropoffType: dropoff.type
    };
  };

  useEffect(() => {
    if (
      formData.pickupLocation === null &&
      formData.dropoffLocations === null &&
      formData.dropoffLocations.length === 0
    ) return;

    const { check, pickupStatus, dropoffStatus, dropoffType, pickupType } = checkIsAirportOrStation(
      formData.pickupLocation,
      formData.dropoffLocations
    );

    if (check) {
      if (dropoffType === "airport" || pickupType === "airport" || dropoffType === "station" || pickupType === "station") {
        setByFormData(prev => ({
          ...prev,
          isAirportTransfer: dropoffType === "airport" || pickupType === "airport",
          isFromAirport: (pickupStatus && pickupType === "airport" ? true : false),
          isToAirport: (dropoffStatus && dropoffType === "airport" ? true : false),
          isStationTransfer: dropoffType === "station" || pickupType === "station",
          isFromStation: (pickupStatus && pickupType === "station" ? true : false),
          isToStation: (dropoffStatus && dropoffType === "station" ? true : false)
        }));
      }
    } else {
      setByFormData(prev => ({
        ...prev,
        isAirportTransfer: false,
        isFromAirport: false,
        isToAirport: false,
        isStationTransfer: false,
        isFromStation: false,
        isToStation: false
      }));
    }
  }, [formData.pickupLocation, formData.dropoffLocations]);

  const handleAddDestination = () => {
    setByFormData((prevForm) => {
      const newDropoffLocation = null;

      return {
        ...prevForm,
        dropoffLocations: [...prevForm.dropoffLocations, newDropoffLocation],
      };
    });
  };

  const handleRemoveDestination = (index) => {
    setByFormData((prevForm) => {
      const newDropoffLocations = [...prevForm.dropoffLocations];
      newDropoffLocations.splice(index, 1);

      return {
        ...prevForm,
        dropoffLocations: newDropoffLocations,
      };
    });
  }

  useEffect(() => {
    var searchAvailableVehicleData = {
      pickupLocation: formData.pickupLocation,
      dropoffLocations: formData.dropoffLocations,
      usageDuration: formData.usageDuration,
      travelDate: formData.travelDate,
      pickupTimeRaw: formData.pickupTimeRaw,
      estpPickupTime: formData.estpPickupTime,
      travelArea: formData.travelArea,
      luggage: formData.luggage,
      pax: formData.pax,
      byTheHourBook: formData.byTheHourBook,
      bookingType: formData.bookingType,
      isAirportTransfer: formData.isAirportTransfer,
      isFromAirport: formData.isFromAirport,
      isToAirport: formData.isToAirport,
      isStationTransfer: formData.isStationTransfer,
      isFromStation: formData.isFromStation,
      isToStation: formData.isToStation,
      longDistance: formData.longDistance,
      totalDistance: formData.totalDistance,
      driverAccomodation: formData.driverAccomodation,
    }

    if (
      formData.pickupLocation != null &&
      formData.dropoffLocations != null &&
      formData.dropoffLocations.length > 0 &&
      formData.travelDate != null &&
      formData.pickupTimeRaw != null &&
      Object.values(formData.pax).some(paxCount => paxCount > 0)
    ) {
      searchAvailableVehicles(searchAvailableVehicleData);
    }
  }, [formData])

  const getTimeFormat = (timeRaw) => {
    if (!timeRaw) {
      return null;
    }

    const [hours, minutes] = timeRaw.split(":").map(Number);

    // Create a new Date object for today with the specified time
    const date = new Date();
    date.setHours(hours, minutes, 0, 0); // Set the time, keep the date as today
    return date
  }

  const handleOnChangeLongDistance = () => {
    setByFormData(prev => ({
      ...prev,
      longDistance: !prev.longDistance,
      totalDistance: 0
    }));
  }

  const handleOnChangeTotalDistance = (e) => {
    setByFormData(prev => ({
      ...prev,
      totalDistance: e.target.value
    }));
  }

  const handleOnChangeDriverAccomodation = () => {
    setByFormData(prev => ({
      ...prev,
      driverAccomodation: !prev.driverAccomodation,
    }));
  }

  return (
    <div className="">
      <div className="row mb-2">
        <div className="col-12">
          <AdminInputLocation
            prefixIcon={<LocationPinIcon />}
            placeholder="Pick-up: Airport, Hotel, Attraction, etc"
            onSelectLocation={handlePickupLocation}
            mb="mb-3"
            label={"Pick-up"}
            value={formData?.pickupLocation?.formatted_address}
          />
        </div>
        <div className="col-12">
          <label className="tw:!mb-1 tw:!text-[15px] tw:!text-[#8D8D8D]">Drop Off</label>
          {formData.dropoffLocations.map((item, index) => (<div key={index}>
            <div className="tw:flex! tw:justify-center! tw:items-center! d-flex gap-2 align-items-start mb-3" >
              <div className="col">
                <AdminInputLocation
                  prefixIcon={<LocationPinIcon />}
                  placeholder="Drop-off: Airport, Hotel, Attraction, etc."
                  onSelectLocation={handleDropOffLocation}
                  mb="mb-0"
                  hasIndex={true}
                  index={index}
                  value={formData?.dropoffLocations[index]?.formatted_address}
                />
              </div>
              {index === formData.dropoffLocations.length - 1 ? (
                <button className="btn bg-gold-light-100 rounded py-2" style={{ height: "50px" }} onClick={handleAddDestination}>
                  <div className="d-flex gap-2 px-3" >
                    <PlusIcon color="#666666" />
                    <p className="m-0 noto">
                      Add destination
                    </p>
                  </div>
                </button>
              ) : (
                <div className="tw:cursor-pointer" onClick={() => handleRemoveDestination(index)}>
                  <CloseIcon color="#EA4335" />
                </div>
              )}
            </div>
          </div>))}

        </div>

      </div>
      <div className="row mb-2">
        <div className="col-3">
          <AdminInputDatePicker
            label={"Travel Date"}
            placeholder="Select travel date"
            prefixIcon={<CalendarAltIcon />}
            onSelectDate={(e) => handleTravelDate(e)}
            mb={""}
            name="travelDate"
            value={formData.travelDate !== null ? moment(formData.travelDate, "YYYY-MM-DD").toDate() : null}
            dateFormat="MMMM d, yyyy"
          />
        </div>
        <div className="col-3">
          <AdminInputTimePicker
            label={"Pick-up Time"}
            placeholder="Select Pick-up Time"
            prefixIcon={<CalendarAltIcon />}
            onSelectDate={handlePickupTime}
            name="travelDate"
            mb="mb-0"
            value={formData.pickupTimeRaw !== null ? getTimeFormat(formData.pickupTimeRaw) : null}
          />
          {/* <p className="fs-13 mt-1 mb-0">
            <span className="fw-bold">
              {formData.estpPickupTime ?? ""}
            </span>
          </p> */}
        </div>
        <div className="col-3">
          <AdminInputPassengers
            label={"Passenger"}
            placeholder="Input Passenger"
            prefixIcon={<PaxIcon />}
            totalAdult={formData.pax.adult}
            totalBaby={formData.pax.baby}
            totalToddler={formData.pax.toddler}
            totalChild={formData.pax.child}
            onChange={handleOnChangePax}
            value={
              formData.pax.adult +
              formData.pax.child +
              formData.pax.toddler +
              formData.pax.baby
            }
          />
        </div>
        <div className="col-3">
          <AdminInputLuggage
            label={"Luggage"}
            placeholder="Input Luggage"
            prefixIcon={<LuggageIcon />}
            totalCabin={formData.luggage.cabinSize}
            totalCheckin={formData.luggage.checkinSize}
            onChange={handleOnChangeLuggage}
            value={
              formData.luggage.cabinSize + formData.luggage.checkinSize
            }
          />
        </div>
      </div>
      <div className="row mb-2">
        <div className="col-3">
          <AdminInput
            mt={"mb-0"}
            placeholder={"Total Distance (Km)"}
            label={"Total Distance (Km)"}
            onChange={handleOnChangeTotalDistance}
            disable={!formData.longDistance}
            value={formData.totalDistance}
            name="totalDistance"
            type="number"
          />
          <AdminCheckbox
            mt={"mt-0 mb-2"}
            label={"Long Distance Needed"}
            onChange={handleOnChangeLongDistance}
            disabled={false}
            checked={formData.longDistance}
            name="longDistance"
          />
        </div>
        <div className="col-3">
          <AdminCheckbox
            mt={"mt-4 pt-2"}
            label={"Driver's Accomodation"}
            onChange={handleOnChangeDriverAccomodation}
            disabled={false}
            checked={formData.driverAccomodation}
            name="driversAccomodation"
          />
        </div>
      </div>
    </div>
  );
};
